import * as React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
const { useEffect, useState } = React;
const Tab3: React.FC = () => {


  useEffect(() => {
  }, [])
  return (
    <div
      className='tab3'
    >
      <iframe src="https://hd.huya.com/huyaDIYzt/11765/pc/index.html" width='100%' scrolling="no" height='4000px' frameBorder="0" id="iFrame1" ></iframe>

    </div>
  )
}

export default Tab3;